import { render, staticRenderFns } from "./EditRecord.vue?vue&type=template&id=1ae0ef29&scoped=true&"
import script from "./EditRecord.vue?vue&type=script&lang=js&"
export * from "./EditRecord.vue?vue&type=script&lang=js&"
import style0 from "./EditRecord.vue?vue&type=style&index=0&id=1ae0ef29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae0ef29",
  null
  
)

export default component.exports